/* eslint-disable @typescript-eslint/no-explicit-any */
import {AwsRum, AwsRumConfig} from 'aws-rum-web';
import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class InsightService {
    private awsRum: AwsRum;
    private currency: string = '';
    private terms: string = '';
    private year: string = '';
    private scenarioZoneFullNames: string[] = [];
    private sourceNames: string[] = [];
    private basecaseNames: string[] = [];
    private scenarioSubtypeNames: string[] = [];
    private weatherYearNames: string[] = [];
    private isAdvancedModeSearch: boolean = false;
    private previewStyle: string = '';
    private previewType: string = 'FORECAST';

    constructor(private readonly router: Router) {
    }

    recordEvent(eventType: string, eventAttributes: any) {
        const json =
            {
                'searchAttributes': {
                    zoneFullNames: this.scenarioZoneFullNames,
                    sourceNames: this.sourceNames,
                    basecaseNames: this.basecaseNames,
                    subtypeNames: this.scenarioSubtypeNames,
                    weatherYearNames: this.weatherYearNames,
                    isAdvancedMode: this.isAdvancedModeSearch
                },
                'currencyAttributes': {
                    currency: this.currency,
                    terms: this.terms,
                    year: this.year
                },
                'previewAttributes': {
                    previewStyle: this.previewStyle,
                    previewType: this.previewType
                },
                'eventAttributes': eventAttributes
            };
        this.awsRum?.recordEvent(eventType, json);
    }

    recordPriceCardEvent(eventType: string, zoneFullNames: string[], subtypeNames: string[], codNames: string[]) {
        const json =
            {
                'priceCardAttributes': {
                    zoneFullNames: zoneFullNames,
                    subtypeNames: subtypeNames,
                    codNames: codNames,
                }
            };
        this.awsRum?.recordEvent(eventType, json);
    }

    recordError(error: any) {
        this.awsRum?.recordError(error);
    }

    addSearchAttributesAwsRum(zoneFullNames: string[], sourceNames: string[], basecaseNames: string[], subtypeNames: string[], weatherYearNames: string[], isAdvancedModeSearch:boolean) {
        this.scenarioZoneFullNames = zoneFullNames;
        this.sourceNames = sourceNames;
        this.basecaseNames = basecaseNames;
        this.scenarioSubtypeNames = subtypeNames;
        this.weatherYearNames = weatherYearNames;
        this.isAdvancedModeSearch = isAdvancedModeSearch;
    }

    clearSearchAttributesAwsRum() {
        this.scenarioZoneFullNames = [];
        this.sourceNames = [];
        this.basecaseNames = [];
        this.scenarioSubtypeNames = [];
        this.weatherYearNames = [];
        this.isAdvancedModeSearch = false;
    }


    addCurrencyAttributesAwsRum(currency: string, terms: string, year: number | null) {
        this.currency = currency;
        this.terms = terms;
        this.year = year == null ? '-1' : year.toString();
    }

    addPreviewAttributesAwsRum(previewStyle: string | null, previewType: string | null) {
      this.previewStyle = previewStyle ?? this.previewStyle;
      this.previewType = previewType ?? this.previewType;
    }

    addSessionAttributesAwsRum(identifier: string, value: string) {
        this.awsRum?.addSessionAttributes({
            [identifier]: value.trim().length === 0 ? 'UNKNOWN' : value
        });
    }

    initAwsRum() {
        try {
            const config: AwsRumConfig = {
                sessionSampleRate: 1,
                eventCacheSize: 2000,
                sessionEventLimit: 0,
                batchLimit: 1000,
                dispatchInterval: 2000,
                identityPoolId: environment.awsRum.identityPoolId,
                endpoint: 'https://dataplane.rum.eu-central-1.amazonaws.com',
                telemetries: [
                    ['http', {
                        recordAllRequests: true,
                        addXRayTraceIdHeader: true
                    }],
                    'errors',
                    'performance',
                    'interactions'
                ],
                allowCookies: true,
                enableXRay: true
            };

            const APPLICATION_ID: string = environment.awsRum.applicationId;
            const APPLICATION_VERSION: string = '1.0.0';
            const APPLICATION_REGION: string = 'eu-central-1';

            this.awsRum = new AwsRum(
                APPLICATION_ID,
                APPLICATION_VERSION,
                APPLICATION_REGION,
                config
            );

            this.router.events.subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    const page = this.removeSearchParamsFromUrl(event.url);
                    this.awsRum.recordPageView(page);
                }
            });

        } catch (error) {
            // Ignore errors thrown during CloudWatch RUM web client initialization
            console.log(error);
        }
    }

    private removeSearchParamsFromUrl(value: string): string {
        const finderIndex = value.indexOf('finder');
        return finderIndex !== -1 ? value.substring(0, finderIndex + 'finder'.length) : value;
    }

}
